// @flow

import NavLink from 'src/components/NavLink/NavLink';
import React from 'react';
import { goBack } from 'src/store/location/location';
import { Button, Text, Hidden } from 'seek-style-guide/react';

const ReturnToJobLink = () => {
  return (
    <Hidden print component={Text} small>
      <Button color="blue" ghost component={NavLink} onClick={goBack}>
        Return to job details
      </Button>
    </Hidden>
  );
};

export default ReturnToJobLink;
